import React from "react";
import { MultiLineField } from "@soqs/common";

const isValid = (name) => {
  if (!name || name.trim() === "") {
    return "A valid description must be provided";
  }
  if (name.length > 500) {
    return "Description must be 500 characters or fewer";
  }
  return undefined;
};

const BODescription = ({ ...rest }) => (
  <MultiLineField
  name={rest.name}
  label={rest.label}
  validate={isValid}
  required={true}
  minLength={0}
  maxLength={500}
  rows={3}
/>
);

export default BODescription;
